<span class="mc-madcap-variable" [attr.madcap:conditions]="conditions">
  <ng-container *ngIf="value === undefined">Loading...</ng-container>
  <ng-container *ngIf="value">{{ value }}</ng-container>
</span>